import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import * as Constants from '../constants';
import { applyAudioSubs } from '../constants/audioSubs';
import HeadingBuilder from '../components/HeadingBuilder';
import TextToSpeech from '../components/TextToSpeech';
import CategoryHeader from '../components/CategoryHeader'
import { useUtils } from "../hooks/useUtils";
import { formatMoney } from '../utils';

export function useLookups() {
  const { t, i18n } = useTranslation();

  function lookup_category ({
    category,
  }) {
    switch (category) {
      case  0: return t('sku.category.optionValue00');  // "Miscellaneous",
      case  1: return t('sku.category.optionValue01');  // "Fruits",
      case  2: return t('sku.category.optionValue02');  // "Vegetables",
      case  3: return t('sku.category.optionValue03');  // "Bread",
      case  4: return t('sku.category.optionValue04');  // "Baking",
      case  5: return t('sku.category.optionValue05');  // "Bakery",
      case  6: return t('sku.category.optionValue06');  // "Dessert",
      case  7: return t('sku.category.optionValue07');  // "Dairy",
      case  8: return t('sku.category.optionValue08');  // "Meat",
      case  9: return t('sku.category.optionValue09');  // "Seafood",
      case 10: return t('sku.category.optionValue10');  // "Alternative Protein",
      case 11: return t('sku.category.optionValue11');  // "Nuts",
      case 12: return t('sku.category.optionValue12');  // "Deli",
      case 13: return t('sku.category.optionValue13');  // "Soups",
      case 14: return t('sku.category.optionValue14');  // "Cans, Jars",
      case 15: return t('sku.category.optionValue15');  // "Pasta, Rice, Cereal",
      case 16: return t('sku.category.optionValue16');  // "Sauces",
      case 17: return t('sku.category.optionValue17');  // "Condiments",
      case 18: return t('sku.category.optionValue18');  // "Herbs, Spices",
      case 19: return t('sku.category.optionValue19');  // "Refrigerated Items",
      case 20: return t('sku.category.optionValue20');  // "Frozen Foods",
      case 21: return t('sku.category.optionValue21');  // "Snacks",
      case 22: return t('sku.category.optionValue22');  // "Beverages",
      case 23: return t('sku.category.optionValue23');  // "Paper Goods",
      case 24: return t('sku.category.optionValue24');  // "Household, Cleaning",
      case 25: return t('sku.category.optionValue25');  // "Personal Care, Beauty",
      case 26: return t('sku.category.optionValue26');  // "Health, Vitamins",
      case 27: return t('sku.category.optionValue27');  // "Pharmacy",
      case 28: return t('sku.category.optionValue28');  // "Baby Products",
      case 29: return t('sku.category.optionValue29');  // "Pet Care",
      case 30: return t('sku.category.optionValue30');  // "Office Supplies",
      case 31: return t('sku.category.optionValue31');  // "Clothing",
      case 32: return t('sku.category.optionValue32');  // "Automotive",
      case 33: return t('sku.category.optionValue33');  // "Electronics",
      case 34: return t('sku.category.optionValue34');  // "Patio, Lawn, Garden",
      case 35: return t('sku.category.optionValue35');  // "Kitchen", follows 23
      case 36: return t('sku.category.optionValue36');  // "Skip for now", comes before 0
      default: return t('sku.category.optionValue00');  // 'Miscellaneous'
    }
    // if add more categories, update js constant 'LAST_SKU_CATEGORY_INDEX'
    // and rb constant 'Constants.sku.conf.category_le'
  };

  function lookup_category_eg ({
    category,
  }) {
    switch (parseInt(category)) {
      case  0: return t('sku.category.examples00');  // "Miscellaneous",
      case  1: return t('sku.category.examples01');  // "Fruits",
      case  2: return t('sku.category.examples02');  // "Vegetables",
      case  3: return t('sku.category.examples03');  // "Bread",
      case  4: return t('sku.category.examples04');  // "Baking",
      case  5: return t('sku.category.examples05');  // "Bakery",
      case  6: return t('sku.category.examples06');  // "Dessert",
      case  7: return t('sku.category.examples07');  // "Dairy",
      case  8: return t('sku.category.examples08');  // "Meat",
      case  9: return t('sku.category.examples09');  // "Seafood",
      case 10: return t('sku.category.examples10');  // "Alternative Protein",
      case 11: return t('sku.category.examples11');  // "Nuts",
      case 12: return t('sku.category.examples12');  // "Deli",
      case 13: return t('sku.category.examples13');  // "Soups",
      case 14: return t('sku.category.examples14');  // "Cans, Jars",
      case 15: return t('sku.category.examples15');  // "Pasta, Rice, Cereal",
      case 16: return t('sku.category.examples16');  // "Sauces",
      case 17: return t('sku.category.examples17');  // "Condiments",
      case 18: return t('sku.category.examples18');  // "Herbs, Spices",
      case 19: return t('sku.category.examples19');  // "Refrigerated Items",
      case 20: return t('sku.category.examples20');  // "Frozen Foods",
      case 21: return t('sku.category.examples21');  // "Snacks",
      case 22: return t('sku.category.examples22');  // "Beverages",
      case 23: return t('sku.category.examples23');  // "Paper Goods",
      case 24: return t('sku.category.examples24');  // "Household, Cleaning",
      case 25: return t('sku.category.examples25');  // "Personal Care, Beauty",
      case 26: return t('sku.category.examples26');  // "Health, Vitamins",
      case 27: return t('sku.category.examples27');  // "Pharmacy",
      case 28: return t('sku.category.examples28');  // "Baby Products",
      case 29: return t('sku.category.examples29');  // "Pet Care",
      case 30: return t('sku.category.examples30');  // "Office Supplies",
      case 31: return t('sku.category.examples31');  // "Clothing",
      case 32: return t('sku.category.examples32');  // "Automotive",
      case 33: return t('sku.category.examples33');  // "Electronics",
      case 34: return t('sku.category.examples34');  // "Patio, Lawn, Garden",
      case 35: return t('sku.category.examples35');  // "Kitchen", follows 23
      case 36: return t('sku.category.examples36');  // "Skip for now", comes before 0
      default: return t('sku.category.examples00');  // 'Miscellaneous'
    }
  };

  function lookup_tz_info ({
    tz_term,
  }) {
    switch (tz_term) {
      case  0: return t('sku.category.optionValue0');  // 'Other'
      case "guam":            return "Guam";
      case "midway_island":   return "Midway Island";
      case "american_samoa":  return "American Samoa";
      case "hawaii":          return "Hawaii";
      case "alaska":          return "Alaska";
      case "pacific_time_us_n_canada":  return "Pacific Time (US & Canada)";
      case "arizona":         return "Arizona";
      case "mountain_time_us_n_canada": return "Mountain Time (US & Canada)";
      case "central_time_us_n_canada":  return "Central Time (US & Canada)";
      case "indiana_east":    return "Indiana (East)";
      case "eastern_time_us_n_canada":  return "Eastern Time (US & Canada)";
      case "puerto_rico":     return "Puerto Rico";
      case "fiji":            return "Fiji";
      case "wellington":      return "Wellington";
      case "new_caledonia":   return "New Caledonia";
      case "sydney":          return "Sydney";
      case "melbourne":       return "Melbourne";
      case "darwin":          return "Darwin";
      case "tokyo":           return "Tokyo";
      case "seoul":           return "Seoul";
      case "perth":           return "Perth";
      case "singapore":       return "Singapore";
      case "bangkok":         return "Bangkok";
      case "rangoon":         return "Rangoon";
      case "dhaka":           return "Dhaka";
      case "kathmandu":       return "Kathmandu";
      case "kolcata":         return "Kolkata";
      case "mumbai":          return "Mumbai";
      case "islamabad":       return "Islamabad";
      case "karachi":         return "Karachi";
      case "kabul":           return "Kabul";
      case "baku":            return "Baku";
      case "tehran":          return "Tehran";
      case "nairobi":         return "Nairobi";
      case "cairo":           return "Cairo";
      case "jerusalem":       return "Jerusalem";
      case "kyiv":            return "Kyiv";
      case "riga":            return "Riga";
      case "berlin":          return "Berlin";
      case "madrid":          return "Madrid";
      case "west_central_africa": return "West Central Africa";
      case "london":          return "London";
      case "monrovia":        return "Monrovia";
      case "azores":          return "Azores";
      case "brasilia":        return "Brasilia";
      case "buenos_aires":    return "Buenos Aires";
      case "montevideo":      return "Montevideo";
      case "newfoundland":    return "Newfoundland";
      case "georgetown":      return "Georgetown";
      case "santiago":        return "Santiago";
      case "caracas":         return "Caracas";
      case "lima":            return "Lima";
      case "bogota":          return "Bogota";
      case "mexico_city":     return "Mexico City";
      case "saskatchewan":    return "Saskatchewan";
      case "mazatlan":        return "Mazatlan";
      case "tijuana":         return "Tijuana";
      default: return t('sku.category.optionValue0');  // 'Other'
    }
  };

  function lookup_voice_info ({
    voice_term,
  }) {
    const entry = Constants.VOICE_CATALOG.find(
      ([ slug ]) => slug === voice_term
    );

    if (! entry)  return Constants.HELP_VOICE_DATA;  // Google|en-US|female
    // An unknown slug is not necessarily bad data - it can be a voice we
    // used to offer and have since dropped. Falling back beats crashing.

    const [ , voiceName, locale, sex ] = entry;

    return voiceName + '|' + locale + '|' + sex;
  };

  // 'Intl.DisplayNames' localizes language and region names for us, so
  // voice labels need no translation keys at all, and a locale added
  // later picks them up for free.
  // We ask for each name in its own language (the endonym - 'Deutsch',
  // not 'German') so a shopper can find their language even when the UI
  // is showing one they don't read.
  // See MDN, 'Intl.DisplayNames' (baseline since Safari 14 / Chrome 81,
  // so it is safe without a polyfill).
  function display_name ({ tag, type, code }) {
    try {
      return new Intl.DisplayNames([tag], { type }).of(code) || code;
    } catch (e) {
      return code;  // engine without 'Intl.DisplayNames', or ICU has no
                    // name for this tag. The raw code still identifies
                    // the entry, so the picker stays usable.
    }
  };

  // The two halves of a voice's name. The picker shows 'langLabel' once
  // as an '<optgroup>' heading and 'optionLabel' on each entry beneath
  // it; a view with no grouping to lean on joins the two, as
  // 'lookup_voice_label' does.
  function voice_label_parts ({ entry }) {
    const [ , voiceName, locale, , displayOverride ] = entry;
    const [ langTag, region ] = locale.split('-');

    const langName =
      display_name({ tag: langTag, type: 'language', code: langTag });

    return {
      langTag,
      langLabel: langName.charAt(0).toUpperCase() + langName.slice(1),
      // Endonyms are lowercase in several languages ('français',
      // 'italiano'). As a group heading they read better capped.
      optionLabel:
        display_name({ tag: locale, type: 'region', code: region })
          + ' · ' + (displayOverride || voiceName),
    };
  };

  // Names one voice on its own - no '<optgroup>' heading is present to
  // supply the language, so it goes into the label.
  function lookup_voice_label ({ voice_term }) {
    const entry =
      Constants.VOICE_CATALOG.find(([ slug ]) => slug === voice_term)
      ||  Constants.VOICE_CATALOG.find(
            ([ slug ]) => slug === Constants.TIPPY_HELP_VOICE
          );
      // An unknown slug - a voice we have since retired - plays through
      // the default voice (see 'lookup_voice_info'), so name that one
      // instead of echoing a slug the shopper never picked.

    if (! entry)  return voice_term;

    const { langLabel, optionLabel } = voice_label_parts({ entry });

    return langLabel + ' · ' + optionLabel;
  };

  // Shapes 'VOICE_CATALOG' into '<optgroup>'s, one per language, so the
  // list reads as a short set of languages rather than 30 loose names.
  function voice_option_groups () {
    const groups = [];

    Constants.VOICE_CATALOG.forEach(
      entry => {
        const { langTag, langLabel, optionLabel } =
          voice_label_parts({ entry });

        let group = groups.find(aGroup => aGroup.tag === langTag);

        if (! group) {
          group = { tag: langTag, label: langLabel, voices: [] };
          groups.push(group);
        }

        group.voices.push({ slug: entry[0], label: optionLabel });
      }
    );

    const uiLang =
      (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

    // The shopper's own language goes first; the rest keep catalog order.
    return groups.filter(aGroup => aGroup.tag === uiLang)
      .concat(groups.filter(aGroup => aGroup.tag !== uiLang));
  };

  function lookupXipLength ({
    countryCode,
  }) {
    switch (countryCode) {
      case  "US": return "3";
      case  "AD": return "2";
      case  "AR": return "5";
      case  "AT": return "2";
      case  "AU": return "2";
      case  "BD": return "2";
      case  "BE": return "2";
      case  "BG": return "2";
      case  "BH": return "1";
      case  "BR": return "3";
      case  "CA": return "3";
      case  "CH": return "2";
      case  "CL": return "3";
      case  "CN": return "4";
      case  "CO": return "4";
      case  "CZ": return "3";
      case  "DE": return "2";
      case  "DK": return "2";
      case  "DZ": return "2";
      case  "EC": return "4";
      case  "EE": return "2";
      case  "EG": return "3";
      case  "ES": return "2";
      case  "FI": return "2";
      case  "FR": return "2";
      case  "GB": return "4";
      case  "GH": return "2";
      case  "GR": return "3";
      case  "HU": return "2";
      case  "ID": return "3";
      case  "IE": return "3";
      case  "IL": return "2";
      case  "IN": return "3";
      case  "IS": return "2";
      case  "IT": return "2";
      case  "JO": return "3";
      case  "JP": return "3";
      case  "KE": return "3";
      case  "KR": return "3";
      case  "KW": return "2";
      case  "LK": return "2";
      case  "LT": return "2";
      case  "LU": return "1";
      case  "LV": return "2";
      case  "MA": return "2";
      case  "MC": return "3";
      case  "MT": return "3";
      case  "MX": return "2";
      case  "MY": return "2";
      case  "NG": return "3";
      case  "NL": return "2";
      case  "NO": return "2";
      case  "NP": return "3";
      case  "NZ": return "2";
      case  "OM": return "1";
      case  "PE": return "3";
      case  "PG": return "1";
      case  "PH": return "2";
      case  "PK": return "2";
      case  "PL": return "2";
      case  "PT": return "3";
      case  "RO": return "2";
      case  "RU": return "3";
      case  "SA": return "3";
      case  "SE": return "3";
      case  "SG": return "2";
      case  "SK": return "3";
      case  "SM": return "4";
      case  "TH": return "2";
      case  "TN": return "2";
      case  "TR": return "2";
      case  "TW": return "3";
      case  "TZ": return "2";
      case  "UA": return "3";
      case  "UY": return "2";
      case  "VE": return "2";
      case  "VN": return "2";
      case  "ZA": return "2";
      default: return "2";
    }
  };

  // Turns the numeric value of the status dropdown into the string the
  // backend expects. Deliberately NOT locale-sensitive: the return value
  // goes on the wire, and Rails validates it against 'enum :status'.
  //
  // These used to come from 't('invitation.status.accepted')' and the
  // like, on the reasoning that translation.json was a handy home for
  // constants. It is not: the es and ht syncs duly translated them, so
  // an es shopper POSTed 'Aceptada', failed validation, and could not
  // accept an invitation at all (fixed 260822). Wire values live in
  // 'Constants' now. For what the shopper reads, see
  // 'lookup_status_label'.
  function lookup_status ({
    status,
  }) {
    return Constants.INVITATION_STATUSES[parseInt(status)]
        || Constants.INVITATION_STATUSES[0];  // 'NotResponded'
  };

  // The shopper-facing name of a status. Takes the wire value the API
  // sends back ('Accepted'), not the dropdown index that
  // 'lookup_status' takes.
  function lookup_status_label ({
    status,
  }) {
    const statusIndex = Constants.INVITATION_STATUSES.indexOf(status);

    return t('invitation.status.label' +
      (statusIndex === -1 ? 0 : statusIndex));
  };

  // The shopper-facing name of a saved time zone, e.g. 'Hora del Este
  // (EE. UU. y Canadá) (-5:00)'.
  //
  // 'circle.time_zone' holds a Rails time-zone name ('Eastern Time (US
  // & Canada)'). That looks like English but is an identifier, not
  // prose: 'Circle' validates it against
  // 'ActiveSupport::TimeZone::MAPPING.keys' and 'clock.rb' hands it to
  // Clockwork as 'tz:' to schedule the daily shared-price job. So it
  // stays as it is on the wire, and only the display is translated -
  // map it back to our own code, which is what the 'circle.tz_name'
  // keys are keyed by.
  function lookup_tz_label ({
    time_zone,
  }) {
    const tzCode = Constants.VALID_TIME_ZONES.find(
      code => lookup_tz_info({tz_term: code}) === time_zone
    );

    return tzCode ? t('circle.tz_name.' + tzCode) : time_zone;
    // A zone Rails knows but our list does not: show what we stored
    // rather than nothing.
  };

  // A plan's shopper-facing name, e.g. 'Up to 3 Shoppers, Monthly'.
  //
  // 'plan.label' cannot be used for this: it is a column in the DB
  // ('db/oneoff/plan_add.rb' seeds it), so it is English for every
  // shopper and no sync can reach it. Build the name instead from the
  // two attributes the serializer already sends - 'max_shoppers' and
  // 'period' - which are data, not language.
  function lookup_plan_name ({
    plan,
  }) {
    if (! plan)  return '';

    const periodName = t('circle.plan.period_' + plan.period, {
      defaultValue: '',
    });

    if (! periodName)  return plan.label;
    // A period we have no name for yet - a plan added after this code.
    // The English 'label' is a poor answer but a better one than a
    // half-built string.

    return t('circle.plan.nameFormat', {
      maxShoppers: plan.max_shoppers,
      period: periodName,
    });
  };

  // The reverse of 'lookup_status': turns the wire value the API sends
  // into the dropdown option value that matches it. Seeding a form
  // straight from an API record needs this, or the select finds no
  // option equal to 'Accepted' and opens on 'Choose one:' instead.
  function lookup_status_index ({
    status,
  }) {
    const statusIndex = Constants.INVITATION_STATUSES.indexOf(status);

    return String(statusIndex === -1 ? 0 : statusIndex);
    // A string, because that is what '<option value>' holds and what
    // the select compares against.
  };

  function lookup_flavor ({
    flavor,
  }) {
    switch (parseInt(flavor)) {
      case  0: return t('invitation.flavor.optionValue0');  // 'circle_wants_shopper'
      case  1: return t('invitation.flavor.optionValue1');  // 'shopper_wants_circle'
      case  2: return t('invitation.flavor.optionValue2');  // 'leader_wants_new_leader'
      default: return t('invitation.flavor.optionValue0');  // 'circle_wants_shopper'
    }
  };

  function lookup_flavor_action ({
    flavor,
  }) {
    if (parseInt(flavor)) {
      switch (parseInt(flavor)) {
        case  0: return t('invitation.flavor.action0');  // 'to join Circle'
        // case  1: return t('invitation.flavor.action1');  // 'to join your Circle'
        case  2: return t('invitation.flavor.action2');  // 'to become Leader of Circle'
        default: return t('invitation.flavor.action0');  // 'to join Circle'
      }
    } else {
      switch (flavor) {
        case  'circle_wants_shopper':    return t('invitation.flavor.action0');
        case  'leader_wants_new_leader': return t('invitation.flavor.action2');
        default: return t('invitation.flavor.action0');  // 'to join Circle'
      }
    }
  };

  function lookup_flavor_headline_tippy ({
    flavor,
  }) {
    switch (parseInt(flavor)) {
      case  0: return t('invitation.formPart.headlineTippyContent0');  // 'invite...to Join Our Circle'
      // case  1: return t('invitation.formPart.headlineTippyContent1');  // 'invite...to Join Your Circle'
      case  2: return t('invitation.formPart.headlineTippyContent2');  // 'invite...to become its new Leader'
      default: return t('invitation.formPart.headlineTippyContent0');  // 'invite...to Join Our Circle'
    }
  };

  function lookup_flavor_invitation_tippy ({
    flavor,
  }) {
    switch (parseInt(flavor)) {
      case  0: return t('invitation.addShopperIdentifier.tippyContentJOCircle');  // 'no help with username'
      // case  1: return t('invitation.addShopperIdentifier.tippyContentJYCircle');  // ?
      case  2: return t('invitation.addShopperIdentifier.tippyContentBecomeLeader');  // 'find username via profile'
      default: return t('invitation.addShopperIdentifier.tippyContentJOCircle');  // 'no help with username'
    }
  };

  function lookup_flavor_label ({
    flavor,
  }) {
    console.log('what is flavorA?', flavor, typeof flavor)
    switch (flavor) {
      case  'circle_wants_shopper': return t('invitation.flavor.label0');  // 'Join Our Circle'
      case  'shopper_wants_circle': return t('invitation.flavor.label1');  // 'Join Your Circle'
      case  'leader_wants_new_leader': return t('invitation.flavor.label2');  // 'Become Leader'
      default: return t('invitation.flavor.label0');  // 'Join Our Circle'
    }
  };

  function lookup_flavor_response_notes ({
    flavor,
  }) {
    console.log('what is flavorB?', flavor, typeof flavor)

    const circleWantsShopperTippyContent =
        t('global.label.options')
      + t('invitation.status.tippyContentNotResponded')
      + ' // '
      + t('invitation.status.tippyContentAcceptRejectCircleWantsShopper')
      + ' // '
      + t('invitation.status.tippyContentImproper');

    const LeaderWantsNewLeaderTippyContent =
        t('global.label.options')
      + t('invitation.status.tippyContentNotResponded')
      + ' // '
      + t('invitation.status.tippyContentAcceptRejectLeaderWantsNewLeader')
      + ' // '
      + t('invitation.status.tippyContentImproper');

    switch (flavor) {
      // meanings for 'Not Responded', 'Accepted', 'Rejected', 'Improper'
      case  'circle_wants_shopper': return circleWantsShopperTippyContent;  // 'Join Our Circle'
      // case  'shopper_wants_circle': return shopperWantsCircleTippyContent;  // 'Join Your Circle'
      case  'leader_wants_new_leader': return LeaderWantsNewLeaderTippyContent;  // 'Become Leader'
      default: return t('invitation.status.tippyContentOptions0');  // 'Join Our Circle'
    }
  };


  function lookup_tax_type ({
    tax_type,
  }) {
    switch (parseInt(tax_type)) {
      case  0: return t('sku.tax_type.optionValue0');  // 'No Tax'
      case  1: return t('sku.tax_type.optionValue1');  // 'Regular'
      case  2: return t('sku.tax_type.optionValue2');  // 'Food'
      default: return t('sku.tax_type.optionValue0');  // 'No Tax'
    }
  };

  //function useLookups()
  return {
    lookupXipLength,
    lookup_tax_type,
    lookup_status,
    lookup_status_label,
    lookup_status_index,
    lookup_plan_name,
    lookup_tz_label,
    lookup_flavor,
    lookup_flavor_action,
    lookup_flavor_headline_tippy,
    lookup_flavor_invitation_tippy,
    lookup_flavor_label,
    lookup_flavor_response_notes,
    lookup_tz_info,
    lookup_voice_info,
    lookup_voice_label,
    voice_option_groups,
    lookup_category_eg,
    lookup_category
  }
}

export function useSkuSorts() {
  function s_by_sku_cat_brand_label( a, b )
  {
    //console.log("sbsli", a)
    if ( a.category < b.category){
      return -1;
    }
    if ( a.category > b.category){
      return 1;
    }
  
    if ( a.brand.toLowerCase() < b.brand.toLowerCase() ){
      return -1;
    }
    if ( a.brand.toLowerCase() > b.brand.toLowerCase() ){
      return 1;
    }
  
    if ( a.label.toLowerCase() < b.label.toLowerCase() ){
      return -1;
    }
    if ( a.label.toLowerCase() > b.label.toLowerCase() ){
      return 1;
    }
  
    if ( a.identifier < b.identifier){
      return -1;
    }
    if ( a.identifier > b.identifier){
      return 1;
    }
  
    return 0;
  }

  //function useSkuSorts()
  return {
    s_by_sku_cat_brand_label
  }
}

export function usePhrasing() {
  const { t, i18n } = useTranslation();
  const { lookup_category } = useLookups();

  const { formatCentsToDollars,
    } = useUtils();

  function typicalWeightString ({
    sku,
  }) {
    // Either: 5.0 lb  -or-  ___ lb
    // Note maybe checking for typical_weight is unnecessary if Weighty items properly require typical_weight?
    // Rails checks WeightyItems for a typical_weight, but still do the check.

    // Hmm, should we also plan for missing 'sku.units'?

    if (sku.type !== 'WeightyItem') {
      return "[error - not weighty]"
    }

    return [
      sku.typical_weight ? sku.typical_weight : '___',
      " ",
      sku.units
    ]
  }

  const shopListIdHeading = ({buttonActionId, tippyAlertTextId}) => {
    const buttonAction = !buttonActionId ? null : buttonActionId;

    return (
      <HeadingBuilder
        containerType  = {buttonAction
          ? 'container-hug-bottom'
          : 'container-hug-bottom-right'
        }
        // When we want 'ID' as a button, then fine to center on the column.
        // If this is label for vertical Order Item, then do right-justify.
        headingText    = {t('ordersList.id_col.label')}
        // ID
        buttonAction   = {buttonAction}
        tippyAlertText = {tippyAlertTextId}
        tippyText      = {Constants.DOT}
        // Click 'ID' button to toggle showing identifier values below.
        // Each item should have an ID. Maybe it's a barcode, or sometimes
        // stores assign their own ID or code for the Sku. You can invent
        // your own ID for the Sku and change it later.
      />
    );
  }

  const shopListBrandHeading = () => {
    return t('ordersList.brand_col.label');
  }

  const shopListNameLabelHeading = ({
          containerTypeNameLabel,
          tippyAlertTextNameLabel }) => {
    return (
      <HeadingBuilder
        containerType  = {
  containerTypeNameLabel ? containerTypeNameLabel : 'container-hug-bottom-left'
        }                 
        headingText    = {t('sku.label.label')}
        // Name/Label
        tippyAlertText = {tippyAlertTextNameLabel}
        tippyText      = {Constants.DOT}
        // Click a label to see details about the item and even change
        // it. // The tooltip for the item shows its category.
      />
    );
  }

  const shopListStoreHeading = () => {
    return t('ordersList.store_col.label');
  }

  const shopListWhoHeading = () => {
    return t('ordersList.who_col.label');
  }

  const shopListUnitCountHeading = ({
    isWeighty = false,
    containerTypeUnitCount,
    tippyAlertTextUc,
    tippyAlertAudioUc,
  }) => {
    return (
      <HeadingBuilder
        containerType  = {
    containerTypeUnitCount ? containerTypeUnitCount : 'container-hug-bottom'
        }                 
        headingText    = {
          isWeighty
            ? t('sku.typical_weight.label')
            : t('ordersList.unit_count_col.label')
        }
        // Unit Count -or- Typical Weight

        tippyAlertText = {tippyAlertTextUc}
        tippyAlertAudio= {tippyAlertAudioUc}
        tippyText      = {Constants.DOT}
        // Shows how many individual units come with each purchase.
        //
        // [and if we are showing Tippy Alert icons, continue with:]
        // Click the blue button to raise your order by one full sku.
    // Then click the pink 'O' sign to add your order to your Circle's orders."
      />
    );
  }

  const shopListPriceHeading = () => {
    return t('ordersList.price_col.label');
  }

  const shopListUnitCostHeading = ({ buttonActionUnitCost }) => {
    return (
      <HeadingBuilder
        containerType  = {
          buttonActionUnitCost 
            ? 'container-hug-bottom'
            : 'container-hug-bottom-right'
        }
        headingText    = {t('ordersList.unit_cost_col.label')}
        // Unit Cost
        buttonAction   = {
          buttonActionUnitCost ? buttonActionUnitCost : null
        }
        tippyText      = {Constants.DOT}
        tippyAlertText = {
          buttonActionUnitCost 
            ? t('ordersList.unit_cost_col.tippyContent')
            : t('ordersList.unit_cost_col.tippyContentTable')
        }
        // Click to toggle showing Unit Cost for the item.
      />
    );
  }

  const shopListUnitQtyHeading = ({
    isForVerticalTable = false,
    sku,
    containerTypeUnitQty,
  }) => {
    const tippyWeighty =
      isForVerticalTable
        ? ( sku.type === 'WeightyItem'
              ? t('ordersList.unit_qty_col.tippyContentWeighty')
              : '' )
        : t('ordersList.unit_qty_col.tippyContentWeighty')

    return (
      <HeadingBuilder
        containerType  = {
          containerTypeUnitQty ? containerTypeUnitQty : 'container-hug-bottom'
        }                 
        headingText    = {t('ordersList.unit_qty_col.label')}
        // Unit Qty
        tippyAlertText = {t('ordersList.unit_qty_col.tippyContent', {
                           tippyWeighty:  tippyWeighty,
                         })}
        tippyText      = {Constants.DOT}
        // How many subunits do you want?
        // For items sold by weight...
      />
    );
  }

  const shopListWantdHeading = ({
    isForVerticalTable=false, sku, weightString='',
  }) => {
    const tippySingular =
      isForVerticalTable
        ? (sku.type === 'MultipackItem'  ||  sku.type === 'WeightyItem')
            ? ''
            : t('ordersList.abs_amt_col.tippyContentSingular')

        : t('ordersList.abs_amt_col.tippyContentSingular')

    const basicWeighty =
      t('ordersList.abs_amt_col.tippyContentWeighty', {
        nameLabel: t('sku.label.label'),
        weightString: weightString,
      })

    const tippyWeighty =
      isForVerticalTable
        ? sku.type === 'WeightyItem'
            ? basicWeighty
            : null
        : basicWeighty

    const tippyLead =
      isForVerticalTable
        ? sku.type === 'SingularItem'
            ? t('ordersList.abs_amt_col.tippyLeadSingular')
              // What percentage of the item do you want?
            : t('ordersList.abs_amt_col.tippyLeadWeightyMultipack')
              // You are getting this much of the item.
              // (100% means you are getting an entire Sku.)
        : t('ordersList.abs_amt_col.tippyLeadSingular')

    return (
      <HeadingBuilder
        containerType  = 'container-hug-bottom-right'
        headingText    = {t('ordersList.abs_amt_col.label')}
        // %Wantd
        tippyAlertText =
          {t('ordersList.abs_amt_col.tippyContent', {
            tippyLead:     tippyLead,
            tippySingular: tippySingular,
            tippyWeighty:  tippyWeighty,
          })}   
        tippyText      = {Constants.DOT}
        // What percentage of the item do you want?
      />
    );
  }

  const shopListRangeNoteHeading = ({
    isForVerticalTable=false,
  }) => {
    return (
      <HeadingBuilder
        containerType  = {
          isForVerticalTable
            ? 'container-hug-bottom-right'
            : 'container-col-hug-bottom'
        }
        headingText    = {t('ordersList.range_note_col.label')}
        //  #-#  i.e. these three chars remind how to show a range
        tippyText      = {Constants.DOT}
        tippyAlertText = {t('ordersList.range_note_col.tippyContent')}
      />
    )
  };

  const shopListOutlayHeading = ({
    buttonActionOutlay,
    showOutlayWithTax,
    containerTypeOutlay,
  }) => {
    return (
      <HeadingBuilder
        containerType  = {
          containerTypeOutlay ? containerTypeOutlay : 'container-hug-bottom'
        }                 
        headingText    = {
                           showOutlayWithTax
                             ? t('ordersList.outlay_col.label_w_tax')
                             : t('ordersList.outlay_col.label')
                         }
        // Outlay
        buttonAction   = {buttonActionOutlay}
        tippyText      = {Constants.DOT}
        tippyAlertText = {t('ordersList.outlay_col.tippyContent')}
        // Your portion of the cost for the item
      />
    )
  };

  const shopListOColHeading = ({ containerTypeO }) => {
    const tippyAlertTextOCol =
                          getOColHeaderTippyContent({isForTextNotAudio: true })

    const tippyAlertAudioOCol =
                          getOColHeaderTippyContent({isForTextNotAudio: false})

    return (
      <HeadingBuilder
        containerType  = {
          containerTypeO ? containerTypeO : 'container-hug-bottom'
        }                 
        headingText    = {t('ordersList.o_col.label')}
        // Having a wacky character for a header doesn't look right, so we'll use "O", not O_COL_SYM.

        tippyAlertText = {tippyAlertTextOCol}
        tippyAlertAudio= {tippyAlertAudioOCol}
        tippyText      = {Constants.DOT}
        // When it turns pink, clicking the "O" sign below is a way to update the database with the amount you want of the product
      />
    )
  };

  const shopListCircleAmtHeading = () => {
    return (
      <HeadingBuilder
        containerType  = 'container-hug-bottom-right'
        headingText    = {t('ordersList.circle_amt_col.label')}
        // Circle Amt
        tippyText      = {Constants.DOT}
        tippyAlertText = {t('ordersList.circle_amt_col.tippyContent')}
        // Shows the combined requested amount from everyone in your Circle for getting an item.
      />
    )
  };

  const shopListCircleMoneyHeading = ({ currencySymbolCircleMoney }) => {
    return (
      <HeadingBuilder
        containerType  = 'container-hug-bottom-right'
        headingText    = {
          t('ordersList.circle_price_col.label', {
            currency_symbol: currencySymbolCircleMoney
          })}
          // Circle $
        tippyText      = {Constants.DOT}
        tippyAlertText = {t('ordersList.circle_price_col.tippyContent')}
        // Shows how much your Circle will spend on an item
      />
    )
  };

  const shopListDetailsHeading = () => {
    return (
      <HeadingBuilder
        containerType  = 'container-hug-bottom-left'
        headingIcon    = {Constants.GET_ICON_DETAILS_HEADING}
        //   /|\  (triangle with a vertical bar)
        tippyText      = {Constants.DOT}
        tippyAlertText = {t('ordersList.details_col.tippyContent')}
        // Click an icon below to see full details for that item and change
        // your order quantity.
      />
    )
  };

  const orderItemNameLabelContent = ({
      sku, tsw, showSlimShopList, showUnitCount, showQtyUnits,
  }) => {
    // Currently, I only expect the 'showUnitCount' and 'showQtyUnits' params
    // to have values when called from 'OrderItemTable'. So, for normal
    // 'OrderItem' invocation, the 'else' condition will set 'const' values.
    const valShowUnitCount =
      typeof showUnitCount !== 'undefined'
        ? showUnitCount
        : showSlimShopList ? true : false;

    const valShowQtyUnits =
      typeof showQtyUnits !== 'undefined'
        ? showQtyUnits
        : (sku.type === 'SingularItem' &! showSlimShopList) ? false : true;

    return (
      <>
        <Tippy content= { lookup_category({category: sku.category}) } >
          <Link to={`/skus/${sku.id}`}>
            <span>{sku.label}</span>
          </Link>
        </Tippy>
        {/* Let's add weight info (selectively) after the label: */}
        {
          weightAndUnitsOfSku({
            sku,
            tsw,
            showUnitCount: valShowUnitCount,
            showQtyUnits:  valShowQtyUnits,
            showWeightAsTswEditLink: true,
          })
        }
      </>
    );
  }

  const headingPlusEmValue = ({heading, value}) => {
    // elements in list need keys, so adapt with React.Fragment
    return [
      <React.Fragment key={heading}>
        {heading}
      </React.Fragment>,
      <em key={value}>&nbsp;{value}</em>
    ];
  }

  const headingPlusValue = ({heading, value}) => {
    // Elements in list need keys, so adapt with React.Fragment.
    // The 'hpv' tag below is make-believe, a meaningless tag
    return [
      <React.Fragment key={heading}>
        {heading}
      </React.Fragment>,
      <swa-hpv key={value}>&nbsp;{value}</swa-hpv>
    ];
  }

  const headingPlusPlayAudio = ({heading, origText}) => {
    // Elements in list need keys, so adapt with React.Fragment.
    return [
      <React.Fragment key={heading}>
        {heading}
      </React.Fragment>,
      <TextToSpeech key={origText.length} text={origText} />
    ];
  }

  const showMaxXChars = ({string="", max=10}) => {
    return string.length > max
      ? (string.slice(0, max) + "\u2026")
      : string;
  }

  const noDotZero = ({num}) => {
    if (Number(num)) {
    return `${Number.parseFloat(Number(num).toFixed(2))}`
    }
    return '';
  }
  const planParticulars = ({
    maxTrips, maxOrders, maxSkuSearches, period=t('global.monthly')
                          }) => {
    return (
      t('circle.planPriceBasic.ppHold')        + maxTrips +
      t('circle.planPriceBasic.ppTripsAnd')    + maxOrders +
      t('circle.planPriceBasic.ppOiMake')      + maxSkuSearches +
      t('circle.planPriceBasic.ppSkuSearches') + period
    )
  }
// Hold up to 140 Trips and 5000 OrderItems // Make up to 1000 Sku Searches moly

  const weightAndUnitsOfSku = ({
    sku, showWeightAsTswEditLink, tsw={}, showUnitCount, showQtyUnits=true
  }) => {
    switch (sku.type) {
      case "MultipackItem":
        return [
          showUnitCount
            ? ` (qty ${noDotZero({num: sku.unit_count})})`
            : ''
        ];
      case "WeightyItem":
        return showWeightAsTswEditLink 
          ? [
              ', ',
              t('global.label.get'),  // get
              ' ',
              <Link to={`/tsw/${tsw.id}/edit`} key={sku.id}>
                <span>{tsw.actual_weight} {sku.units}</span>
              </Link>
            ]
          : [
              ', ',
              t('global.label.est'),  // EST
              ' ',
              typicalWeightString({sku}).join("")
            ];
      case "SingularItem":
        return [
          showQtyUnits
            ? `, ${noDotZero({num: sku.quantity})} ${sku.units}`
            : ''
        ];
      default:
        return [ t('sku.label.whatTypeErrorMsg') ];
        // Is item singular, multipack, or weighty?
    }
  }


  function tippySkuIdentifierIsWeightyString ({
    isWeighty,
  }) {
    return isWeighty ? t('sku.identifier.weightyTippyContent') : ''
  }

  function typicalWeightLabel () {
    return t('sku.typical_weight.label') + ' ' + t('sku.typical_weight.label2');
  }

  function typicalWeightTippyText () {
    return t('sku.typical_weight.tippyContent') + ' '
         + t('sku.typical_weight.tippyContent2');
  }

  function priceLabel ({isWeighty, currency_symbol}) {
    return isWeighty
      ? t('sku.price.weightyLabel', {currency_symbol: currency_symbol})
      : t('sku.price.label',        {currency_symbol: currency_symbol})
  }

  function priceTippyText ({isWeighty, currency_symbol}) {
    return isWeighty
     ? t('sku.price.weightyTippyContent')
     : t('sku.price.tippyContent')
       + t('sku.price.currencyCautionTippyContent', {
           currency_symbol: currency_symbol
         });
  }

  function postalCodeTippyText ({countryCode, xipLength}) {
    return t('circle.postal_code.tippyContent', {
      countryCode: countryCode,
      xipLength:   xipLength,
      zipCodeTerm: t('circle.postal_code.label'),
    });
  }

  function tippySkuDetailDquoteNote () {
    return t('sku.detail.tippyContentDquoteConvert010')
         + t('global.abbrev.inch')
         + t('sku.detail.tippyContentDquoteConvert020');
  }

  function circleTaxTippyText () {
    return t('circle.tax_rate.tippyContent')
         + ' // '
         + t('circle.tax_rate.unitsExplainer65');
  }

  function circleFoodTaxTippyText () {
    return t('circle.tax_rate_food.tippyContent')
         + ' // '
         + t('circle.tax_rate_food.unitsExplainer25');
  }

  function tripTaxTippyText () {
    return t('trip.tax_rate.tippyContent')
         + ' '
         + t('trip.tax_rate.otherLocation')
         + ' // '
         + t('circle.tax_rate.unitsExplainer65');
  }

  function tripFoodTaxTippyText () {
    return t('trip.tax_rate_food.tippyContent')
         + ' '
         + t('trip.tax_rate.otherLocation')
         + ' // '
         + t('circle.tax_rate_food.unitsExplainer25');
  }

  function getIdColTippyText () {
    return t('global.label.click')
         + " '"
         + t('ordersList.id_col.label')
         + "' "
         + t('ordersList.id_col.tippyContentClick')
         + t('ordersList.id_col.tippyContent')
  }

  function getShowTippyHelpIconLabel () {
    return t('shopper.showTippyHelpIcon.label1')
         + Constants.QMARK_SYM
         + t('shopper.showTippyHelpIcon.label2');
  }

  function getShowTooltipsTippy () {
    return t('shopper.showTippyHelpIcon.tippyContent10')
         + Constants.QMARK_SYM
         + t('shopper.showTippyHelpIcon.tippyContent20');
  }

  function getShowTooltipsTippyAudio () {
    return t('shopper.showTippyHelpIcon.tippyContent10')
         + t('shopper.showTippyHelpIcon.tippyContent20');
  }

  function getShowVideoTipsTippy () {
    return t('shopper.showVideoTipsIcon.tippyContent10')
         + Constants.VIDEO_SYM
         + t('shopper.showVideoTipsIcon.tippyContent20');
  }

  function getShowVideoTipsTippyAudio () {
    return t('shopper.showVideoTipsIcon.tippyContent10')
         + t('shopper.showVideoTipsIcon.tippyContent20');
  }

  function getShopperShortnameTippyText () {
    return t('shopper.shortname.tippyContent010')
         + t('shopper.shortname.tippyContent020')
         + t('shopper.shortname.tippyContent040');
  }

  function getShopperShortnameTippyAudio () {
    return t('shopper.shortname.tippyContent010')
         + t('shopper.shortname.tippyContent030')
         + t('shopper.shortname.tippyContent040');
  }

  function getUnitCountColHeaderTippyText (
                        { isForTextNotAudio, isWeighty=false, weightString }) {
    return (
       // Note that 'isWeighty' should only be true at 'OrderItemTable'
       (isWeighty
         ? t('ordersList.unit_count_col.tippyContentWeighty')
         + t('global.paraMarker')
         + t('ordersList.unit_count_col.tippyContentGet', {
             labelGet: t('global.label.get'),
             skuLabel: t('sku.label.label'),
             weightString: weightString,
           })

         : t('ordersList.unit_count_col.tippyContent')
       )

         + t('global.paraMarker')
         + t('orderItem.blue_unit_count.tippyContent', {
              character: isForTextNotAudio
                ? Constants.O_COL_SYM : t('global.label.circle')
           })
    )
  }

  function getSingularString ({ sku }) {
    return (
      (sku.type === 'SingularItem' && sku.quantity > 0 && sku.units?.length > 0)
        ? `${noDotZero({num: sku.quantity})} ${sku.units}`
        : ''
    )
  }

  function getWeightString ({ sku, actualWeight }) {
    return (
      sku.type === 'WeightyItem'  ?  `${actualWeight} ${sku.units}`  :  ''
    )
  }

  // 260221: Not sure this comment is still relevant, but:
  // In table data, it's overwhelming to present Tippy icon info for each row.
  // If showing tippy Alert icons is enabled then show content that blends headerTippy and rowTippy.
  // Else, we can just show the header-based Tippy content for the column header.
  const getUnitCountColHeaderTippyContent = (
                           { shopper, isWeighty=false, weightString='', }) => {
    return (
      shopper.show_tippy_help_alert_icons
        ? getUnitCountColHeaderTippyText(
                          {isForTextNotAudio: true, isWeighty, weightString, })
        : t('ordersList.unit_count_col.tippyContent')
    )
  }

  const getUnitCountColHeaderAudioTippyContent = (
                           { shopper, isWeighty=false, weightString='', }) => {
    return (
      shopper.show_tippy_help_alert_icons
        ? getUnitCountColHeaderTippyText(
                            {isForTextNotAudio: false, isWeighty, weightString})
        : t('ordersList.unit_count_col.tippyContent')
    )
  }

  function getOColHeaderTippyContent ({ isForTextNotAudio }) {
    return t('ordersList.o_col.tippyContent', {
              unitQty:   t('ordersList.unit_qty_col.label'),
              pctWantd:  t('ordersList.abs_amt_col.label'),
              character: isForTextNotAudio
                ? Constants.O_COL_SYM : t('global.label.circle')
           })
  }

  function getOColTippyContent ({ isForTextNotAudio, isForSkusFound=false }) {
    return t('sku.o_col.tippyContent', {
      character: isForTextNotAudio
                              ? Constants.O_COL_SYM : t('global.label.circle'),
      clickPhrase: isForSkusFound
                          ? t('sku.o_col.belowClick') : t('sku.o_col.clickThe'),
      postScript:  isForSkusFound ? '' : t('sku.o_col.noteReEditSku'),
    })
  }

  function getNameColComment ({ weightString = '' }) {
    const weightyProvision =
      weightString.length > 0
        ? t('ordersList.unit_count_col.tippyContentGet', {
            labelGet: t('global.label.get'),
            skuLabel: t('sku.label.label'),
            weightString: weightString,
          })
          + t('global.paraMarker')
        : '';

    return t('ordersList.nameCol.tippyContent10')
         + t('global.paraMarker')
         + weightyProvision
         + t('ordersList.nameCol.tippyContent20');
  }

  function getWithdrawTheQuestionTippyContent ({ object_name }) {
    return t('global.withdrawTheQuestion', {
      object_name: object_name
    })
  }

  function get_tax_type_suffix ({ taxType }) {
    switch (taxType) {
      case 'no_show':  // Return empty string
        return '';
      case 0:  // 'No Tax'
        return ' N';
      case 1:  // 'Regular'
        return ' R';
      case 2:  // 'Food'
        return ' F';
      default:
        return ' N';
    }
  }

  function getAnyRefundTippyContent ({ planInterval, refundAmountInteger }) {
    if (planInterval === 'week') {
      return t('subscription.cancelButton.weeklyPlanRefund')
    }
    switch (refundAmountInteger) {
      case 0:
        return t('subscription.cancelButton.noRefund')
      default:
        return t('subscription.cancelButton.partialRefund',
          {refund_amount: formatCentsToDollars({ cents: refundAmountInteger })}
        )
    }
  }

  function getMaxCapacityTippyContent ({ hasOpenInvites, hasReachedMaxPlan }) {
    return t('circleShopper.inviteShopperButton.atMaxCapacityTippyContent',
      {
        maybe_cancel_invitation: (
          hasOpenInvites
            ? t('circleShopper.inviteShopperButton.solnCancelInvitation')
            : null
        ),
        maybe_switch_plans: (
          hasReachedMaxPlan
            ? t('circleShopper.inviteShopperButton.switchPlans')
            : null
        )
      }
    )
  }

  function getSkuQtyTippyContent ({skuType}) {
    return t('sku.quantity.tippyContent', {
      morePerSkuType:
        skuType === "MultipackItem"
          ? t('sku.quantity.multipackQuantityNotes')
          : skuType === "SingularItem"
            ? t('sku.quantity.singularQuantityNotes')
            : null
    })
  }

  function getSkuUnitTippyContent ({skuType}) {
    return t('sku.units.tippyContent', {
      morePerSkuType:
        skuType === "MultipackItem"
          ? t('sku.units.multipackUnitNotes', {
              skuQuantityLabel: t('sku.quantity.label')
            })
          : null
    })
  }

  function getTippyShareSkuPerCircle ({ circleShareSkuBasic }) {
    return (
      circleShareSkuBasic
        ? t(
            'sku.shareable.tippyContentPerCircle', {
              shareBasicSkuInfo: t('circle.share_sku_basic.label'),
              skuShareCirclePolicy: 
            circleShareSkuBasic ? t('global.label.yes') : t('global.label.no'),
              details: t('sku.detail.label')
            }
          )
        : ''
    )
  } 

  function getSkuCatTippyInfo () {

    // Yikes! This list requires manual maintenance!
    // It must match the order of values returned by 'SkuCategoryPicker'.
    // Fortunately, this list should not change much, so maintenance should
    // not be difficult.
    const subscripts = [
      '36', '00', '01', '02', '03', '04', '05',
      '06', '07', '08', '09', '10', '11', '12',
      '13', '14', '15', '16', '17', '18', '19',
      '20', '21', '22', '23', '35', '24', '25',
      '26', '27', '28', '29', '30', '31', '32',
      '33', '34'
    ]

    const initialValue = "";
    const skuCatTippyInfo = subscripts.reduce(
      (accumulator, subscript, currentIndex) => accumulator +
        t('sku.category.optionValue'+subscript) +
        ' - ' +
        t('sku.category.examples'+subscript) +
        ((parseInt(currentIndex) === subscripts.length - 1) ? "" : ' // '),
        // We want ' // ' to be inserted between each set of category info.
        // 'join' is usually the tool for this, but we are building the string
        // using 'reduce'. So, look at this as: Append ' // ' to each set,
        // but not for the last set. Creates lots of substrings like:
        // "Cans, Jars - tuna or canned meats, olives // "

      initialValue,
    );

    return skuCatTippyInfo;
  }

  // The rules themselves live in 'constants/audioSubs', bucketed by how
  // much of a language they depend on. All this does is say which
  // language the text is in.
  //
  // Pass 'i18nKey' as well as the text, and a '<key>_audio' sibling in
  // the translation file - if one exists - is spoken instead of the
  // displayed string.
  //
  // Reach for it only when a rule in 'audioSubs' cannot do the job,
  // which is when the fix depends on the sentence rather than on a
  // word. Two examples, both already in that file:
  //
  //   'e.g.' always wants 'for example' - every time, everywhere, no
  //   matter the sentence. One rule covers it forever. This does NOT
  //   need an '_audio' twin.
  //
  //   'read' and 'lead' each have two pronunciations, and which one is
  //   right depends on grammar no pattern can see. That is why the file
  //   carries three phrase-by-phrase hacks - 'should lead to', 'that
  //   read CSV', 'read on.' - for just those two words. A fourth
  //   sentence would need a fourth hack. THIS is what '_audio' is for:
  //   write that one sentence the way it should sound and be done.
  //
  // The rules still run over a spoken form afterward, so an '_audio'
  // string only needs to say what no rule can. Everything a rule does
  // reach still applies to it: leave 'Sku' in an '_audio' string and
  // the 'respell' entry for it in 'AUDIO_SUBS' turns it into 'skew'.
  //
  // It is NOT the way to handle a number: whether digits are an
  // identifier to read out one by one or a quantity to read as a
  // magnitude is settled at the call site, by interpolating the
  // '_SPOKEN' form of a 'FAQ_*' constant. No locale file should ever
  // hold a bare identifier.
  //
  // As of 260820 nothing uses '_audio'; it is here for the first
  // language that needs it.
  function getAudioText ({ originalText = "", i18nKey = "" }) {
    const spokenForm =
      i18nKey
        ? t(i18nKey + '_audio', { defaultValue: '' })
        : '';
        // '_audio' matches how i18next names a context variant, so the
        // sibling sorts next to its key and reads as deliberate.

    return applyAudioSubs({
      text: spokenForm || originalText,
      textLang:
        (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0],
        // 'en-US' and 'en' share one bucket, so drop the region.
    });
  }

  //function usePhrasing()
  return {
    shopListIdHeading,
    shopListBrandHeading,
    shopListNameLabelHeading,
    shopListStoreHeading,
    shopListWhoHeading,
    shopListUnitCountHeading,
    shopListPriceHeading,
    shopListUnitQtyHeading,
    shopListUnitCostHeading,
    shopListWantdHeading,
    shopListRangeNoteHeading,
    shopListOutlayHeading,
    shopListOColHeading,
    shopListCircleAmtHeading,
    shopListCircleMoneyHeading,
    shopListDetailsHeading,
    orderItemNameLabelContent,
    headingPlusEmValue,
    headingPlusValue,
    headingPlusPlayAudio,
    getAnyRefundTippyContent,
    getMaxCapacityTippyContent,
    postalCodeTippyText,
    tippySkuDetailDquoteNote,
    circleTaxTippyText,
    circleFoodTaxTippyText,
    tripTaxTippyText,
    tripFoodTaxTippyText,
    getIdColTippyText,
    getShowTippyHelpIconLabel,
    getShowTooltipsTippy,
    getShowTooltipsTippyAudio,
    getShowVideoTipsTippy,
    getShowVideoTipsTippyAudio,
    getShopperShortnameTippyText,
    getShopperShortnameTippyAudio,
    getSingularString,
    getWeightString,
    getUnitCountColHeaderAudioTippyContent,
    getUnitCountColHeaderTippyContent,
    getUnitCountColHeaderTippyText,
    getOColHeaderTippyContent,
    getOColTippyContent,
    getAudioText,
    getSkuQtyTippyContent,
    getSkuUnitTippyContent,
    getTippyShareSkuPerCircle,
    getSkuCatTippyInfo,
    getNameColComment,
    getWithdrawTheQuestionTippyContent,
    get_tax_type_suffix,
    tippySkuIdentifierIsWeightyString,
    typicalWeightLabel,
    typicalWeightTippyText,
    priceLabel,
    priceTippyText,
    showMaxXChars,
    noDotZero,
    planParticulars,
    weightAndUnitsOfSku,
    typicalWeightString
  }
}

export function useFormats() {
  const { lookup_category } = useLookups();

  function checkDecimalInput ({
    numInput,
  }) {
    return numInput.toString()
                   .replace(/[^.\d]/g, '')   // delete non-digits (and preserve '.')
                   .replace(/^0*[.]/, '0.')  // chg ".5|0.5|00.5" to "0.5"
                   .replace(/^0+(\d)/, "$1") // disallow "021" (rm leading zeros)
                   .replace(/^0+0$/, '0')     // chg "00|000" to "0"
                   ;
    // TODO: why does it sometimes take a click somewhere else to actuate?
  }

  function chgTippySepsToList ({ originalText = "" }) {
    return (
      <>
        {originalText.split(Constants.TIPPY_SEPARATOR).map((line, index) => (
          <React.Fragment key={index}>
            <li>{line}</li>
          </React.Fragment>
        ))}
      </>
    )
  }

  function getCatHeader ({
    k,  // string for key
    sku,
    o,  // OrderItem
    catSeen,
  }) {
    // while sku.category should not be null, we can still watch for it
    const catSeenIndex =  (sku.category ?? 0);

    // Generate CategoryHeader text if this is the first time seeing this
    // category. Else return null.
    const catHeader =
      // if this is first seen in category (count now at 0), show the header
      catSeen[catSeenIndex] === 0
        ? <CategoryHeader
            categoryText = { lookup_category({category: catSeenIndex}) }
      key = {o.id.toString() + sku.id.toString() + o.shopper_id.toString() + k}
          />
        : null;  // we'll smush the nulls via 'flat'

    // mark that we've seen one of this category (increment count)
    catSeen[catSeenIndex] += 1;

    return catHeader;
  }

  function spaceUnits ({
    units,
  }) {
    return <>
      {` ${units}`}
    </>
  }

  //function useFormats()
  return {
    getCatHeader,
    spaceUnits,
    chgTippySepsToList,
    checkDecimalInput
  }
}

export function usePricing() {

  function chooseDecimalScaleQty ({
    sku,
  }) {
    switch (sku.type) {
      case  "MultipackItem": return 0;  // Unit Qty
      case  "SingularItem": return 1;  // Abs Amt

      case  "WeightyItem": return 2;   // Unit Qty
      // 2 for typical_weights like 12.87 lb, and we want to match cost exactly

      default: return 0;
    }
  };

  function s_by_price_date_desc( a, b )
  {
    if ( a.price_date < b.price_date ){
        return 1;
    }
    if ( a.price_date > b.price_date ){
      return -1;
    }
    return 0;
  }

  function chopParenS( units )
  {
    return units.replace(/[(]s[)]$/, '')
  }

  function getTswObject ({
    sku,
    trip,
    tripSkuWeights,
  }) {
    const tswObj =
      sku.type === 'WeightyItem'
        ? tripSkuWeights.find(tsw =>
            tsw.trip.id === trip.id  &&  tsw.sku.id === sku.id
          )
        : null;

    return tswObj;
  }

  function getActualWeight ({
    sku,
    trip,
    tripSkuWeights,
  }) {
    const tswObj = getTswObject({ sku, trip, tripSkuWeights });
    console.log('tsw tswObj: ', tswObj)
    return tswObj  ? tswObj.actual_weight : undefined;
  }

  function getUnitCost ({
    currency_symbol,
    cstu,             // currency_subunit_to_unit
    sku,
    sku_price,
  }) {

    if (sku_price < 0.00001) {
      return formatMoney({
        amount: 0,
        currency_symbol,
        currency_subunit: cstu
      });
    }

    const unitCost =
      sku_price / (sku.quantity || sku.unit_count || 1);
      
    // return unitCost with (at least) three significant digits
    if (unitCost >= 1) {
      return formatMoney({
        amount: unitCost,
        currency_symbol,
        currency_subunit: cstu
      });
    }

    if (unitCost >= 0.1) {
      return formatMoney({
        amount: Math.round(1000 * unitCost)  / 1000,
        currency_symbol,
        currency_subunit: 1000
      });
    }

    if (unitCost >= 0.01) {
      return formatMoney({
        amount: Math.round(10000 * unitCost)  / 10000,
        currency_symbol,
        currency_subunit: 10000
      });
    }

    if (unitCost >= 0.001) {
      return formatMoney({
        amount: Math.round(100000 * unitCost)  / 100000,
        currency_symbol,
        currency_subunit: 100000
      });
    }

    if (unitCost >= 0.0001) {
      return formatMoney({
        amount: Math.round(1000000 * unitCost)  / 1000000,
        currency_symbol,
        currency_subunit: 1000000
      });
    }

    // Something is wrong if we get to this point!
    // Assumption: $0.0000[0-9][0-9][0-9] will look bad and trigger action by Shopper.
    // Shopper should change the parameters that make up unitCost.
    return formatMoney({
      amount: Math.round(10000000 * unitCost)  / 10000000,
      currency_symbol,
      currency_subunit: 10000000
    });
  }

  function getPrice ({
    sku_id,
    trip,
    prices
  }) {
    console.log("gp sku_id", sku_id)  // TODO: Should we test this?
    // Among all prices, find prices for this sku whose price_date occurs on or
    // before the trip date. Reverse sort this list by date and take first one.
    //const price_obj = prices.filter(p => p.sku.id == order.sku.id
    const price_obj = prices.filter(p => p.sku.id == sku_id
                                      && p.price_date <= trip.day)
                            .sort(s_by_price_date_desc)[0];
  
    console.log("gp price_obj", price_obj);
  
    const p =
        typeof price_obj !== 'undefined'
        ? ( typeof price_obj.price !== 'undefined'
            ? (
                ! Number.isNaN(price_obj.price)
                  ? price_obj.price
                  : 0
              )  // FIX ME: What's really the best in this case?
            : 0
          )
        : 0;
    
    if (p === 0) {
        // FIX ME: Poor messaging for this error:
        console.log("got price of '0.00' for sku:", sku_id);
    }

    // Get discount amount
    const d =
      typeof price_obj !== 'undefined'
        ? ( typeof price_obj.discount_amount !== 'undefined'
            ? (
                (! Number.isNaN(price_obj.discount_amount)  // discount_amount exists, (is not NaN)
                      && price_obj.discount_amount > 0
                      && trip.day >= (price_obj.discount_start_date || price_obj.price_date)
                      && trip.day <= price_obj.discount_end_date)  // "ISO Date" vals like: 2022-11-28
                  ? price_obj.discount_amount
                  : 0
              )
            : 0
          )
        : 0;
    console.log("oi gp discount: ", d);
    
    return p - d;
  }

  //function usePricing()
  return {
    chooseDecimalScaleQty,
    chopParenS,
    getActualWeight,
    getTswObject,
    getUnitCost,
    getPrice
  }
}